module.exports = __webpack_public_path__ + "static/media/OnionSoup.2d81e7e6.png";